import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useRouter } from '../../router';
const _preserve = React.version;


import ReactJsonView from '@microlink/react-json-view';

import { Box, Button, Checkbox, Link } from "@cloudscape-design/components";

import { FormField, Modal, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiMagnifyPlusOutline, mdiRefresh } from '@mdi/js';
import { Icon } from '@mdi/react';
import DPModal from '../../../../components/DPModal';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import SelectUser from '../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setLoading, setParameters } from '../../../commons/functions';


type ItemLog = { idLog: number; idUser: number; date: string; time: string; log: string; route: string; displayName: string; ip: string; data: any, type: string; id: number, site: string, module: string };
const pageSize = 20;
export const SystemLogs = () => {
    const { menu, parameters, data } = useGlobalState();

    const { navigate } = useRouter();
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [modalPreview, setModalPreview] = useState(false);
    const [showSystem, setShowSystem] = useState(false);
    const [idUser, setIdUser] = useState(0);

    const [logs, setLogs] = useState<ItemLog[]>([]);
    const [log, setLog] = useState<ItemLog>();


    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        if (parameters.date && parameters.date !== "")
            handleRefresh()
    }, [parameters.date]);
    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/system/logs/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    ...(idUser > 0 && { idUser: idUser }),
                    date: parameters.date,
                    order: "desc",
                    orderBy: "idLog"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            if (dataWeb && dataWeb.logs) {
                const processedLogs = dataWeb.logs.map((d: any) => {
                    // Defensive check: find the user first
                    const user = d.idUser !== 0 ? getUser(d.idUser, data) : null;

                    return {
                        ...d,
                        displayName: user?.displayName ?? "Sistema"
                    };
                });
                setLogs(processedLogs);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const filtered = logs.filter((item) => {
        if (!showSystem && item.idUser === 0) return false;
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.log, item.ip, item.displayName, item.type, item.route, item.module, item.site].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });

    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);
    //}, [emails]);

    const [preferences, setPreferences] = React.useState(undefined);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <Favorites />

                    }>Bitácora de transacciones</Header>
                    <Table
                        stickyHeader
                        stripedRows
                        variant="embedded"

                        columnDefinitions={[
                            {
                                id: 'time',
                                header: 'Hora',
                                cell: (item: ItemLog) => <FormField label={""}>{item.time} <Link onClick={() => setLog(item)}><Icon path={mdiMagnifyPlusOutline} size={1} /></Link></FormField>,
                                width: 120,
                            },
                            {
                                id: 'log',
                                header: 'Usuario/Acción',
                                cell: (item: ItemLog) => (
                                    <FormField label={item.idUser === 0 ? "SISTEMA" : getUser(item.idUser, data)?.displayName ?? ""}>
                                        {item.log}
                                    </FormField>
                                ),
                            },
                            {
                                id: 'ID',
                                header: 'ID',
                                cell: (item: ItemLog) => {
                                    if (item?.type && item.type !== "") {
                                        return (
                                            <FormField label={item.type}>
                                                {item?.id > 0 ? item?.id : ""}
                                            </FormField>
                                        );
                                    }
                                    return null; // make sure to return something
                                },
                                minWidth: 80,
                                width: 80,
                            },
                            {
                                id: 'site',
                                header: 'App',
                                cell: (item: ItemLog) => item.site,
                            },
                        ]}

                        pagination={
                            filtered.length > pageSize && (
                                <Pagination
                                    currentPageIndex={currentPageIndex}
                                    pagesCount={Math.ceil(filtered.length / pageSize)}
                                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                />
                            )
                        }
                        filter={
                            < SpaceBetween direction="horizontal" size="xs" >
                                <SpaceBetween direction="vertical" size="xs">
                                    <TextFilter
                                        disabled={logs.length === 0 || !logs}

                                        filteringPlaceholder="Filtrar"
                                        filteringText={filterValue}
                                        onChange={({ detail }) => {
                                            setFilterValue(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                    <Checkbox checked={showSystem} onChange={(detail) => setShowSystem(detail.detail.checked)}>Mostrar sistema</Checkbox>
                                </SpaceBetween>
                                <SelectUser value={idUser} onConfirm={(user) => {
                                    if (!user) {
                                        setIdUser(0);
                                        return;
                                    }
                                    setIdUser(user.idUser)
                                }} />
                                <DPModal date={parameters.date}
                                    today
                                    end={new Date()}
                                    onConfirm={(date) => {
                                        const updatedParameters = {
                                            ...parameters,
                                            date: date
                                        };
                                        setParameters(updatedParameters);
                                    }} />
                                <Button style={{ root: btnIconForm }} onClick={() => handleRefresh()}><Icon path={mdiRefresh} size={1} /></Button>

                            </SpaceBetween >
                        }
                        items={paginated}
                    />
                    {!!log && (
                        <Modal size="large" visible={!!log} onDismiss={() => setLog(undefined)} header={<Header>Usuario: {log?.displayName}</Header>}>
                            <SpaceBetween size="s" direction="vertical">
                                <>
                                    <SpaceBetween size="s" direction="horizontal">
                                        {log?.route && log?.route !== "" && (
                                            <Box float="left"><BadgeCustom color="yellow">{log.route}</BadgeCustom></Box>
                                        )}

                                        {log?.module && log?.module !== "" && (
                                            <Box float="right"><BadgeCustom color="violet">{log.module}</BadgeCustom></Box>
                                        )}
                                    </SpaceBetween>
                                    {log && (
                                        <ReactJsonView src={log.data}
                                            theme={parameters.theme === "light" ? "rjv-default" : "ashes"}
                                            name={false}
                                            style={{ minHeight: 300 }}
                                            collapsed={1}
                                            collapseStringsAfterLength={30}
                                            groupArraysAfterLength={10}
                                            displayObjectSize={false}
                                            displayDataTypes={false}
                                            enableClipboard={false}
                                        />
                                    )}
                                </>
                            </SpaceBetween>
                        </Modal>
                    )}

                </SpaceBetween >
            }
        />
    );
};
